import { render, staticRenderFns } from "./due.vue?vue&type=template&id=5aca6a3e&"
import script from "./due.vue?vue&type=script&lang=js&"
export * from "./due.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports